import { decode } from 'html-entities';

export const stringUtils = {
  serialize,
  toInputUppercase,
  toInputLowerCase,
  sanitizeHTML,
  sanitizeScriptHTML,
  stripHtmlTags
};

function serialize(obj) {
  let str = '?' + Object.keys(obj).reduce(function (a, k) {
    a.push(k + '=' + encodeURIComponent(obj[k]));
    return a;
  }, []).join('&');
  return str;
}

function toInputUppercase(e) {
  var start = e.target.selectionStart;
  var end = e.target.selectionEnd;
  e.target.value = e.target.value.toUpperCase();
  e.target.setSelectionRange(start, end);
};

function toInputLowerCase(e) {
  var start = e.target.selectionStart;
  var end = e.target.selectionEnd;
  e.target.value = e.target.value.toLowerCase();
  e.target.setSelectionRange(start, end);
};

//function sanitizeHTML(html) {
//  // Substitui <div>, <p> e outras tags específicas por uma tag segura ou por nada.
//  let sanitizedHTML = html;

//  sanitizedHTML = sanitizedHTML.replace(/<div>/g, ' ').replace(/<\/div>/g, ' ');
//  sanitizedHTML = sanitizedHTML.replace(/<p>/g, ' ').replace(/<\/p>/g, ' ');
//  sanitizedHTML = sanitizedHTML.replace(/<br>/g, ' '); // Substitui <br> por espaço
//  sanitizedHTML = sanitizedHTML.replace(/<\/?script[^>]*>/g, ' '); // Remove qualquer <script> (para evitar XSS)

//  return sanitizedHTML;
//};

function sanitizeHTML(html) {
  if (!html) return '';

  let sanitizedHTML = html
    .replace(/<\/?(div|p|br)[^>]*>/g, ' ') // Remove <div>, <p> e <br> substituindo por espaço
    .replace(/<\/?(ol|ul|li|strong|em|u|b|i)[^>]*>/g, ' ') // Remove <div>, <p> e <br> substituindo por espaço
    .replace(/<\/?script[^>]*>/g, '') // Remove <script> por segurança
    .replace(/&nbsp;/g, ' ') // Substitui &nbsp; por espaço normal
    .replace(/\s+/g, ' '); // Substitui múltiplos espaços por um único espaço

  return sanitizedHTML.trim();
}

function sanitizeScriptHTML(html) {
  if (!html) return '';

  let sanitizedHTML = html
    .replace(/<\/?script[^>]*>/g, '') // Remove <script> por segurança

  return sanitizedHTML.trim();
}

function stripHtmlTags(html) {
  if (!html) return '';

  // Remove <script> tags por segurança
  let sanitized = html.replace(/<\/?script[^>]*>/gi, '');

  // Substitui algumas tags de bloco por quebras de linha
  sanitized = sanitized
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<\/h[1-6]>/gi, '\n')
    .replace(/<li>/gi, '• ') // lista com bolinha

    // Para garantir que duplas <div><p> não gerem quebras duplas
    .replace(/(<[^>]+>)/g, '') // Remove o restante das tags HTML

    .replace(/\n{2,}/g, '\n'); // Evita quebras de linha duplicadas

  return decode(sanitized.trim());
}

